import { DRIVE_FILES_URL } from '@/consts/urls';
import { getContext } from '@/context';
import getAuthJsonHeaders from '@/requests/common/getAuthJsonHeaders';

import type { UserReaction } from '@/types';

type Params = {
  id: string;
  reaction: UserReaction | null;
};

const setFileReaction = async ({ id, reaction }: Params): Promise<boolean> => {
  try {
    const response = await getContext().utils.api.fetch(
      `${DRIVE_FILES_URL}/${id}`,
      {
        method: 'PATCH',
        body: JSON.stringify({ attributes: { userReaction: reaction } }),
        headers: getAuthJsonHeaders(),
      }
    );
    return response.ok;
  } catch {
    return false;
  }
};

export default setFileReaction;
